/**
 * TODO - Temp
 */
export const PARTNERS_DISPLAY_PRIORITY = [
	"tim",
	"c6bank",
	"itau",
	"itaucard",
	"anhanguera",
	"carrefour",
	"recovery",
	"nubank",
	"credz",
	"uzecartoes",
	"btg",
	"arc",
	"bradescard",
	"ibi",
	"havan",
	"credigy",
	"liftcred",
	"cielo",
	"credsystem",
	"dacasa",
	"bradesco",
	"lojasrenner",
	"renner",
	"riachuelo",
	"bancodobrasil",
	"itapeva",
	"ipanema",
	"ativossa",
	"hoepers",
	"neon",
	"net",
	"clarofatura",
	"claro",
	"omni",
	"via",
	"sky",
	"vivo",
	"asp",
	"sophus",
	"portoseguro",
	"biva",
	"yduqs",
	"cea",
	"pernambucanas",
	"frd-fmu",
	"dscards",
	"rede",
	"bvfinanceira",
	"ibi-old",
	"dmcard",
	"santander",
	"brk",
	"marisa",
	"telefonica",
	"hipercard",
	"nextel",
	"credicard",
	"casasbahia",
	"leader",
	"bancovotorantim",
	"magazineluiza",
	"santanderfin",
	"losango",
	"avon",
	"natura",
	"boticario",
	"crefisa",
	"edp",
	"extra",
	"caixa",
	"mercadopago",
	"bmg",
	"original",
	"hsbc",
	"embratel",
	"cetelem",
	"banrisul",
	"gvt",
	"bancocacique",
	"fmu",
	"sorocred",
	"bvfin",
	"americanexpress",
	"cifra",
	"light",
	"comgas",
	"eletropaulo",
	"terra",
	"uol",
	"casavida",
	"bancointer",
	"sulamerica",
	"conectcar",
	"carsystem",
	"santinvest",
	"bancorcirenault",
	"bancorcinissan",
	"zema",
	"bv",
	"aegea",
	"queroquero",
	"bancopan",
	"oi",
	"netinterno",
	"mgw",
	"colombo",
];
